<template>
  <div class="maintenance" v-if="!isProcessing">
    <maintenance-menu class="maintenance__menu" v-for="item in items" :key="item.title" :item="item" />
  </div>
</template>

<script>
import MaintenanceMenu from '@/components/common/menu.vue'
export default {
  name: 'maintenance',
  components: { MaintenanceMenu },
  data () {
    return {
      items: [
        { title: 'メンテナンスの開始', content: 'メンテナンスを開始します。', to: 'maintenance_start' },
        { title: 'メンテナンスの終了', content: 'メンテナンスを終了させます。', to: 'maintenance_end' }
      ]
    }
  },
  mounted () {
    this.$store.commit('setProcessing', false)
  },
  computed: {
    /**
     * @return {Boolean} 処理中かどうか
     */
    isProcessing () {
      return this.$store.getters.isProcessing
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/sass/size.scss';
@import '@/assets/sass/color.scss';

.maintenance {
  width: 100vw;
  max-width: $max_width;
  min-height: calc(100vh - #{$header_height});
  padding: 0 $padding_width $padding_height;
  margin: $header_height auto 0 auto;
}
</style>
